export default __webpack_public_path__ + "static/media/bg4.7acf4588.jpg";